import React from 'react';
import { Steps} from 'antd';
import cn from 'classnames';

import cls from './Delivery.module.scss'

export const Delivery = () => (
        <div className={cn(['half', cls.page])}>

            <h1>Доставка и оплата</h1>

            <Steps
                direction="vertical"
                items={[
                    {
                        status: 'process',
                        title: 'Выберите товар',
                        description: 'Выберите товар и подходящий аромат. Если товар предполагает разные арматы, вы можете подобрать требуемые самостоятельно или доверить выбор нам, отметив пункт “Доверяю вашему выбору”. Нажмите “Добавить в корзину”.',
                    },
                    {
                        status: 'process',
                        title: 'Перейдите в корзину',
                        description: 'Проверьте состав заказа. Введите ваши контактые данные, необходимые для оформления заказа. Выберете способ доставки. Стоимость доставки будет рассчитана индивидуально, менеджер уточнит детали.',
                    },
                    {
                        status: 'process',
                        title: 'Оформите заказ',
                        description: 'Оплатить заказ можно на сайте. Для оплаты выберите удобный для вас способ и следуйте инструкциям банка.',
                    },
                    {
                        status: 'process',
                        title: 'Ожидайте доставку или приезжайте к нам',
                        description: 'После оплаты заказа, на указанную вами почту поступит чек об оплате. Также, при выборе способа доставки СДЭК/Ozon будет сгенерирована накладная с указанием трек-номера, с помощью которого вы сможете отследить доставку.',
                    },
                    {
                        status: 'process',
                        title: 'Наслаждайтесь приятным ароматом',
                    },
                ]}
            />

        </div>
    )